import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import NumberFormat from "react-number-format";
import { Select } from "antd";
import {
  DATE_FORMAT_FOR_API
} from "../../../../constants/constants";
import moment from "moment";
import CustomChip from "../../../general/chips";
import { Checkbox } from "@ts-digital/vrc";
import { deadlinesPayment } from "../../../../constants/scadenze";
import { VaporDatePicker } from "../../../vapor";

import "./style.css";

const Option = Select.Option;

const ManualContent = props => {
  const {
    setCheckLowerAmount,
    deadlinesDetail,
    dateValue,
    setDateValue,
    paymentValue,
    setPaymentValue,
    initialValue,
    editedValue,
    setEditedValue,
    isResidueDeadline,
    checkbox,
    setCheckbox,
    setDateValueResidue,
    dateValueResidue,
    isDrawer,
    isMultipleReconciliation,
    movementAmount
  } = props;
  const [showLess, setShowLess] = useState(true);

  const isFiscalSocialSecurity = !isMultipleReconciliation
    ? deadlinesDetail && deadlinesDetail.scope === "fiscal_social_security"
    : false;

  const [disableRegister, setDisableRegister] = useState(false);

  const handleChange = () => {
    setCheckbox(!checkbox);
  };

  let scopes = [];

  for (let item in deadlinesPayment) {
    if (deadlinesPayment.hasOwnProperty(item)) {
      if (item !== "PMXA") {
        scopes.push(<Option value={item}>
          {<FormattedMessage id={deadlinesPayment[item]} />}
        </Option>);
      }
    }
  }

  let modePayment = [];
  for (let key in deadlinesPayment) {
    if (
      (isFiscalSocialSecurity &&
        deadlinesPayment.hasOwnProperty(key) &&
        ["PM01", "PM04", "PM08", "PM23", "PMXC"].indexOf(key) > -1 &&
        key !== "PMXA") ||
      (!isFiscalSocialSecurity &&
        deadlinesPayment.hasOwnProperty(key) &&
        key !== "PMXA" &&
        key !== "PMXC")
    ) {
      if (paymentValue === key) {
        modePayment.splice(
          0,
          0,
          <CustomChip
            style={{ margin: "5px", cursor: "pointer" }}
            key={"option_" + key}
            active={paymentValue === key}
            onClick={() => setPaymentValue(key)}
            description={<FormattedMessage id={deadlinesPayment[key]} />}
          />
        );
      } else {
        modePayment.push(<CustomChip
          style={{ margin: "5px", cursor: "pointer" }}
          key={"option_" + key}
          active={paymentValue === key}
          onClick={() => setPaymentValue(key)}
          description={<FormattedMessage id={deadlinesPayment[key]} />}
        />);
      }
    }
  }
  const onPaymentChange = value => setPaymentValue(value);
  return (
    <React.Fragment>
      <div
        className="totalAmountContainer"
        style={{
          flexDirection: !isDrawer && "row",
          alignItems: isDrawer && "center"
        }}
      >
        <div className="dbx-deadline-register-date-and-amount">
          <div className="dbx-deadline-register-manual-amount">
            <div className="lblToPay">
              <b>
                {!isMultipleReconciliation ? (
                  isResidueDeadline ? (
                    deadlinesDetail.totalAmount > 0 ? (
                      <FormattedMessage id="deadlines.amountToCollect" />
                    ) : (
                      <FormattedMessage id="deadlines.amountToPay" />
                    )
                  ) : (
                    <FormattedMessage id="deadlines.balance" />
                  )
                ) : movementAmount > 0 ? (
                  <FormattedMessage id="deadlines.amountToCollect" />
                ) : (
                  <FormattedMessage id="deadlines.amountToPay" />
                )}{" "}
                *
              </b>
            </div>
            <div
              className="nFDeadlines"
              id="dbx-deadline-payment-dialog-amount"
            >
              <NumberFormat
                className={
                  disableRegister ? "nFDeadlines errorEmpty" : "nFDeadlines"
                }
                readOnly={
                  isFiscalSocialSecurity ||
                  isResidueDeadline ||
                  isMultipleReconciliation
                    ? true
                    : false
                }
                allowNegative={false}                
                value={editedValue ? numeral(editedValue).format("0,0.00") : null}
                // defaultValue={editedValue}
                displayType={"input"}
                suffix={" €"}
                fixedDecimalScale={true}
                decimalScale={2}
                thousandSeparator={"."}
                decimalSeparator={","}
                onValueChange={
                  !isMultipleReconciliation
                    ? values => {
                      const { value } = values;
                      setCheckLowerAmount(false);
                      if (parseFloat(value) === 0 || value === "") {
                        setDisableRegister(true);
                        setEditedValue(null);
                      } else {
                        setDisableRegister(false);
                      }
                      // setInitialValue(parseFloat(value !== "" ? value : null));
                      setEditedValue(parseFloat(value !== "" ? value : null));
                    }
                    : () => {}
                }
              />
            </div>
            {!initialValue && (
              <span className="deadlines-registerPaymentAmountZero">
                <FormattedMessage id="deadlines.pages.detail.registerPaymentAmountZero" />
              </span>
            )}
          </div>

          <div className="dbx-deadline-register-manual-date">
            <div className="lblToPay">
              <b>
                {isResidueDeadline ? (
                  <FormattedMessage id="deadlines.pages.detail.deadlineDate" />
                ) : 
                  deadlinesDetail.totalAmount < 0 ? (
                    <FormattedMessage id="deadlines.pages.detail.paymentDate" />
                  ) : 
                    <FormattedMessage id="deadlines.pages.detail.saleDate" />
                }{" "}
                *
              </b>
            </div>
            <div>
              <VaporDatePicker
                getPopupContainer={(trigger) => trigger.parentNode}
                allowClear={false}
                dropdownClassName="modalOverlay"
                value={
                  isResidueDeadline
                    ? moment(dateValueResidue)
                    : moment(dateValue)
                }
                onChange={value => {
                  isResidueDeadline
                    ? setDateValueResidue(moment(value).format(DATE_FORMAT_FOR_API))
                    : setDateValue(moment(value).format(DATE_FORMAT_FOR_API));
                }}
              />
            </div>
          </div>
          {!isDrawer && (
            <div className="dbx-payment-select-container">
              <div className="labelDialogContent" style={{ paddingBottom: 14 }}>
                {
                  <FormattedMessage id="deadlines.pages.table.paymentTypeMinus" />
                }{" "}
                *
              </div>
              <Select
                dropdownClassName="modalOverlay"
                placeholder="Scegli una modalità..."
                size="large"
                style={{ width: 190 }}
                value={
                  paymentValue ? (
                    <FormattedMessage
                      id={`deadlines.payment.${paymentValue}`}
                    />
                  ) : (
                    "undefined"
                  )
                }
                onChange={value => onPaymentChange(value)}
              >
                {scopes}
              </Select>
            </div>
          )}
          {isResidueDeadline ? (
            <div className="dbx-deadline-register-manual-suspend">
              <Checkbox
                onChange={handleChange}
                checked={checkbox}
                label="Sospendi"
              ></Checkbox>
            </div>
          ) : null}
        </div>
        {isDrawer && (
          <div className="dbx-deadline-register-manual-type">
            <div className="lblToPay">
              <b>
                <FormattedMessage id="deadlines.pages.detail.paymentType" /> *
              </b>
            </div>
            <div className="deadlinesPaymentChip">
              {showLess ? modePayment.slice(0, 3) : modePayment}
            </div>

            <div
              className="showMoreAndLess"
              onClick={() => setShowLess(!showLess)}
            >
              {showLess ? (
                <FormattedMessage id="deadlines.pages.detail.showMore" />
              ) : (
                <FormattedMessage id="deadlines.pages.detail.showLess" />
              )}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ManualContent;
